module.exports = __webpack_public_path__ + "img/backyard-bushes-by-water.c28e823d.webp";